import { render } from "./MaterialTraceDetail.vue?vue&type=template&id=a57f6a30&scoped=true"
import script from "./MaterialTraceDetail.vue?vue&type=script&lang=js"
export * from "./MaterialTraceDetail.vue?vue&type=script&lang=js"

import "./MaterialTraceDetail.vue?vue&type=style&index=0&id=a57f6a30&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57f6a30"]])

export default __exports__